import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-chat-input',
    template: `
    <div class="input-group">
  <input
      type="text"
      class="form-control"
      placeholder="Type message..."
      #message
      (keypress)="searchText()"
      (keydown.enter)="onSubmit()"
      (keyup.enter)="message.value = ''"
      (keyup.escape)="dismiss.emit()">
  <div class="input-group-append">
    <button type="submit" class="btn btn-primary" (click)="onSubmit()">
    <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
      {{ buttonText }}
    </button>
  </div>
</div>
  `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./chat-input.component.css'],
    standalone: false
})
export class ChatInputComponent implements OnInit {
  @Input() public buttonText = 'Send';
  @Input() public focus = new EventEmitter();
  @Input() public clearSearch = new Subject();
  @Output() public send = new EventEmitter();
  @Output() public searchto = new EventEmitter();
  @Output() public dismiss = new EventEmitter();
  @ViewChild('message') message!: ElementRef;

  ngOnInit() {
    this.focus.subscribe(() => this.focusMessage());
    this.clearSearch.subscribe(() => {
      this.clearMessage();
      this.focusMessage();
    });
  }

  public focusMessage() {
    this.message.nativeElement.focus();
  }

  public getMessage() {
    return this.message.nativeElement.value;
  }

  public clearMessage() {
    this.message.nativeElement.value = '';
  }

  onSubmit() {
    const message = this.getMessage();
    if (message.trim() === '') {
      return;
    }
    this.send.emit({ message });
    this.clearMessage();
    this.focusMessage();
  }
  searchText() {
    const message = this.getMessage();
    if (message.trim() === '') {
      return;
    }
    this.searchto.emit({ message });
  }
}
